import { APIStatus } from '@application/common/enums/api-status';
import { createSlice } from '@reduxjs/toolkit';
import { GetAllAssignmentReasonAsync, GetAssignmentReasonByClientTaskNumberAsync, CreateAssignmentReasonAsync, UpdateAssignmentReasonAsync, UpdateAssignmentReasonStatusAsync, DeleteAssignmentReasonAsync } from './assignmentReasonThunk';
const initialState = {
    status: APIStatus.IDLE
};
export const assignmentReasonSlice = createSlice({
    name: 'assignmentReason',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(GetAllAssignmentReasonAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(GetAllAssignmentReasonAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
            state.AssignmentAllReasons = action.payload;
            state.AssignmentReasons = action.payload.filter((item) => item.createdBy !== '00000000-0000-0000-0000-000000000000');
        })
            .addCase(GetAllAssignmentReasonAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(GetAssignmentReasonByClientTaskNumberAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(GetAssignmentReasonByClientTaskNumberAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
            state.AssignmentReasonByClientTaskNumber = action.payload.filter((item) => item.createdBy !== '00000000-0000-0000-0000-000000000000');
        })
            .addCase(GetAssignmentReasonByClientTaskNumberAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(CreateAssignmentReasonAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(CreateAssignmentReasonAsync.fulfilled, (state) => {
            state.status = APIStatus.IDLE;
        })
            .addCase(CreateAssignmentReasonAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(UpdateAssignmentReasonAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(UpdateAssignmentReasonAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
            const updated = action.payload;
            if (state.AssignmentAllReasons) {
                state.AssignmentAllReasons = state.AssignmentAllReasons.map((r) => (r.id === updated.id ? updated : r));
            }
            if (state.AssignmentReasons) {
                state.AssignmentReasons = state.AssignmentReasons.map((r) => (r.id === updated.id ? updated : r));
            }
        })
            .addCase(UpdateAssignmentReasonAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(UpdateAssignmentReasonStatusAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(UpdateAssignmentReasonStatusAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
            const updated = action.payload;
            if (state.AssignmentAllReasons) {
                state.AssignmentAllReasons = state.AssignmentAllReasons.map((r) => (r.id === updated.id ? updated : r));
            }
            if (state.AssignmentReasons) {
                state.AssignmentReasons = state.AssignmentReasons.map((r) => (r.id === updated.id ? updated : r));
            }
        })
            .addCase(UpdateAssignmentReasonStatusAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(DeleteAssignmentReasonAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
            const id = action.meta.arg;
            if (state.AssignmentAllReasons) {
                state.AssignmentAllReasons = state.AssignmentAllReasons.filter((r) => r.id !== id);
            }
            if (state.AssignmentReasons) {
                state.AssignmentReasons = state.AssignmentReasons.filter((r) => r.id !== id);
            }
        })
            .addCase(DeleteAssignmentReasonAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
    }
});
export default assignmentReasonSlice.reducer;
